export enum TestIds {
  COMPONENT_NAME_INPUT = 'component-name-input',
  EXPIRY_DATE = 'expiry-date',
}
